var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatYouGet5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_431_10792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#8970F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 17.333V50.6663H90.6668V17.333H17.3335ZM57.3335 37.333H27.3335V30.6663H57.3335V37.333ZM67.3335 37.333C66.6742 37.333 66.0298 37.1375 65.4816 36.7712C64.9334 36.405 64.5062 35.8844 64.2539 35.2753C64.0016 34.6662 63.9356 33.996 64.0642 33.3494C64.1928 32.7028 64.5103 32.1088 64.9765 31.6427C65.4426 31.1765 66.0366 30.859 66.6832 30.7304C67.3298 30.6018 68 30.6678 68.6091 30.9201C69.2182 31.1724 69.7388 31.5996 70.1051 32.1478C70.4713 32.6959 70.6668 33.3404 70.6668 33.9997C70.6668 34.8837 70.3156 35.7316 69.6905 36.3567C69.0654 36.9818 68.2175 37.333 67.3335 37.333ZM77.3335 37.333C76.6742 37.333 76.0298 37.1375 75.4816 36.7712C74.9334 36.405 74.5062 35.8844 74.2539 35.2753C74.0016 34.6662 73.9356 33.996 74.0642 33.3494C74.1928 32.7028 74.5103 32.1088 74.9765 31.6427C75.4426 31.1765 76.0366 30.859 76.6832 30.7304C77.3298 30.6018 78 30.6678 78.6091 30.9201C79.2182 31.1724 79.7388 31.5996 80.1051 32.1478C80.4713 32.6959 80.6668 33.3404 80.6668 33.9997C80.6668 34.8837 80.3156 35.7316 79.6905 36.3567C79.0654 36.9818 78.2175 37.333 77.3335 37.333ZM89.6335 75.233L93.4335 71.8997L90.1002 66.133L85.2668 67.7663C84.1967 66.8643 82.9788 66.1539 81.6668 65.6663L80.6668 60.6663H74.0002L73.0002 65.633C71.6882 66.1205 70.4703 66.8309 69.4002 67.733L64.5668 66.0997L61.2335 71.8663L65.0335 75.1997C64.7668 76.587 64.7668 78.0124 65.0335 79.3997L61.2335 82.733L64.5668 88.4997L69.4002 86.8663C70.4703 87.7685 71.6882 88.4789 73.0002 88.9663L74.0002 93.9997H80.6668L81.6668 89.033C82.9788 88.5455 84.1967 87.8351 85.2668 86.933L90.1002 88.5663L93.4335 82.7997L89.6335 79.4663C89.9002 78.0678 89.9002 76.6315 89.6335 75.233ZM77.3335 83.9997C76.015 83.9997 74.726 83.6087 73.6297 82.8761C72.5334 82.1436 71.6789 81.1024 71.1743 79.8842C70.6697 78.6661 70.5377 77.3256 70.7949 76.0324C71.0522 74.7392 71.6871 73.5513 72.6194 72.619C73.5518 71.6866 74.7397 71.0517 76.0329 70.7944C77.3261 70.5372 78.6665 70.6692 79.8847 71.1738C81.1029 71.6784 82.1441 72.5329 82.8766 73.6292C83.6092 74.7255 84.0002 76.0145 84.0002 77.333C83.9949 79.0995 83.2908 80.7921 82.0417 82.0412C80.7926 83.2903 79.1 83.9944 77.3335 83.9997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 77.333H27.3335V70.6663H54.9802C56.6552 65.0824 60.3576 60.3265 65.3602 57.333H17.3335V90.6663H58.2002C55.463 86.7592 53.9964 82.1035 54.0002 77.333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_431_10792",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_10792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_10792",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatYouGet5);
export default __webpack_public_path__ + "static/media/WhatYouGet5.239844821c5f7b9bc3cc80730f931b98.svg";
export { ForwardRef as ReactComponent };